import actions from 'actions/rfqs'
import { createFormViewContainer } from 'factories/FormView'
import {
  createChildItemsDispatchToProps,
  createDocumentsDispatchToProps,
  createLinkedItemsDispatchToProps,
} from 'helpers/formViews'
import documentActions from 'actions/documents'
import rfqItemActions from 'actions/rfqs/rfqItems'
import locationActions from 'actions/locations'
import formInstanceActions from 'actions/formInstances'
import rfqSupplierActions from 'actions/rfqs/rfqSuppliers'
import Component from 'components/Rfqs/FormView'

export default createFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    newItem: (params) => dispatch(actions.newItem(params)),
    getAddressList: (params) => dispatch(locationActions.getAddressList(params)),
    populateRfqItems: (params) => dispatch(rfqItemActions.populateRfqItems(params)),
    saveRfq: (params, options) => dispatch(actions.saveRfq(params, options)),
    deleteRfq: (rfqId) => dispatch(actions.deleteItem(rfqId)),
    cancelRfq: (params) => dispatch(actions.cancelRfq(params)),
    closeRfq: (params) => dispatch(actions.closeRfq(params)),
    emailRfq: (params) => dispatch(actions.emailRfq(params)),
    sendRfq: (params) => dispatch(actions.sendRfq(params)),
    resendRfq: (params) => dispatch(actions.sendRfq(params)),
    getSupplierPrices: (rfqId) => dispatch(actions.getSupplierPrices(rfqId)),
    updatePrices: (params) => dispatch(actions.updatePrices(params)),
    reopenRfq: (rfqId) => dispatch(actions.reopenRfq(rfqId)),
    ...createDocumentsDispatchToProps(dispatch, documentActions),
    ...createChildItemsDispatchToProps(dispatch, 'Rfq', rfqItemActions),
    ...createChildItemsDispatchToProps(dispatch, 'RfqSupplier', rfqSupplierActions),
    ...createLinkedItemsDispatchToProps(dispatch, 'FormInstance', formInstanceActions),
  }),
})(Component)
